import React from "react";
import { getField } from "../../../util/DynamicItemUtils";

import FormAPFiling from "./FormAPFiling";

export default function DefaultItem({ item, toggle }: any) {
  return getField(item, "contenttypetitle") ? (
    <FormAPFiling item={item} shouldToggle={toggle} />
  ) : (
    <div>
      <h3>{getField(item, "title")}</h3>
      <div>{getField(item, "content")}</div>
    </div>
  );
}
